export default function RouteLoading() {
    return <div role="status" aria-label="Loading" style={{ minHeight: 240, display: 'grid', placeItems: 'center' }}>
        <svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true">
            <circle cx="20" cy="20" r="16" fill="none" stroke="#DEDCF6" strokeWidth="4" />
            <path d="M20 4a16 16 0 0 1 16 16" fill="none" stroke="#5E639B" strokeWidth="4">
                <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="1s" repeatCount="indefinite" />
            </path>
        </svg>
    </div>
}
